export default __webpack_public_path__ + "static/media/note-without-author.69cc8e5e.png";